const IntegrationsTabContainer = () => {
  return <div>IntegrationsTabContainer</div>;
};

export default IntegrationsTabContainer;
